export default __webpack_public_path__ + "images/435947f2b0ca4be0119e6fae60e88fed-3_4K_1920x544.jpg";